import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { Customer } from '@shared/models';

import { AccessControlPipe } from '../../../pipes/access-control.pipe';

export type CustomerDetailsAction = 'SUSPEND' | 'UNSUSPEND' | 'REMOVE';

@Component({
  selector: 'app-customer-details-header',
  templateUrl: './customer-details-header.component.html',
  imports: [AsyncPipe, AccessControlPipe, RktIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class CustomerDetailsHeaderComponent {
  @Input() customer!: Customer | null;

  @Input() isControlsDisabled = true;

  @Output() btnClicked = new EventEmitter<CustomerDetailsAction>();
}
